import './src/styles/global.css'
import '@cloudogu/my-cloudogu-service-lib'

import React from 'react'
import {ReactKeycloakProvider} from '@react-keycloak/web'
import keycloaks from './keycloak'

let keycloak;

const origin = window.location.origin;
if (origin.startsWith("https://staging-docs.cloudogu.com") || origin.startsWith("http://localhost")) {
    keycloak = keycloaks.staging;
} else {
    keycloak = keycloaks.productive;
}

export const wrapRootElement = ({element}) => {
    return (<ReactKeycloakProvider
        authClient={keycloak}
        initOptions={{
            onLoad: "check-sso",
            silentCheckSsoRedirectUri: window?.location?.origin + '/silent-check-sso.html',
            checkLoginIframe: false
        }}
    >
        {element}
    </ReactKeycloakProvider>)
}

/**
 * When the pathname matches "/" (webserver/dev mode) or "/lang/" (google bucket hosting), a redirect to the
 * actual language is triggered (e.g. "/de/").
 */
function createLanguageRedirect() {
    const languages = require("./i18n/config.json").map(e => e.code);
    if (window?.location?.pathname.match(/^((\/lang\/?)|(\/)|(\/index.html\/?))$/g)) {
        const browserLanguage = navigator?.language ?? "";
        let languageShort = browserLanguage;
        if (browserLanguage.includes("-")) {
            languageShort = browserLanguage?.split("-")[0];
        }
        if (browserLanguage.includes("_")) {
            languageShort = browserLanguage?.split("_")[0];
        }
        const actualLanguage = (languages.includes(languageShort)) ? languageShort : "en";

        const redirectTo = ((new URL(document.location)).searchParams).get('redirectTo');
        if (!!redirectTo) {
            window.location.href = `${window.location.origin}${redirectTo}`;
        } else {
            window.location.pathname = `/${actualLanguage}/`;
        }
    }
}

export const onClientEntry = async () => {
    createLanguageRedirect();
}

export const onRouteUpdate = async () => {
    createLanguageRedirect();
}
